import { EventService } from './EventService'

declare global {
  // eslint-disable-next-line no-var
  var __eventService: EventService | undefined
}

export const getEventService = (): EventService => {
  globalThis.__eventService ??= EventService.getInstance()
  return globalThis.__eventService
}
